import React, { Component } from "react";
import StaffMemberCard from "./StaffMemberCard";
import ReactOwlCarousel from 'react-owl-carousel';

class Staff extends Component {

    staff = [
        { id: 1, name: "Claudio Marinelli", title: "Coach Serie B Softball", imgLink: "claudio_marinelli.jpg" },
        { id: 2, name: "Marco Duimovich", title: "Manager Serie A Baseball", imgLink: "marco_duimovich.jpg" },
        { id: 3, name: "Alessandro Fois", title: "Manager Serie B Softball", imgLink: "alessandro_fois.jpg" },
        { id: 4, name: "Andrea Osella", title: "Coach U15/U18 Softball", imgLink: "andrea_osella.jpg" },
        { id: 5, name: "Antonio Figueroa", title: "Pitching Coach Serie A Baseball", imgLink: "antonio_figueroa.jpg" },
        { id: 6, name: "Federico Pucci", title: "Coach Serie A Baseball", imgLink: "federico_pucci.jpg" },
        { id: 7, name: "Federico Sassoli", title: "Coach Serie A Baseball", imgLink: "federico_sassoli.jpg" },
        { id: 8, name: "Filippo Anichini", title: "Mini Baseball", imgLink: "filippo_anichini.jpg" },
        { id: 9, name: "Margherita Ceccanti", title: "Coach U13, U15, U18 Softball", imgLink: "margherita_ceccanti.jpg" },
        { id: 10, name: "Marina Centrone", title: "Manager U15/U18 Softball", imgLink: "marina_centrone.jpg" },
        { id: 11, name: "Niccolo' Brusini", title: "Coach Serie B, U18 e U15 Softball", imgLink: "niccolo_brusini.jpg" },
        { id: 12, name: "Paolo Gentilini", title: "Coach Serie C Baseball", imgLink: "paolo_gentilini.jpg" },
        { id: 13, name: "Paolo Ranieri", title: "Coach Serie C/U15 Reds", imgLink: "paolo_ranieri.jpg" },
        { id: 14, name: "Simona Grateni", title: "Coach Serie B Softball", imgLink: "simona_grateni.jpg" },
        { id: 15, name: "Simone Burci", title: "Coach U15 Blacks Baseball", imgLink: "simone_burci.jpg" },
        { id: 16, name: "Walter Fedi", title: "Manager serie C e U18 Baseball", imgLink: "walter_fedi.jpg" },
        { id: 17, name: "Marta Bartalozzi", title: "U13 e U15 Softball Coach,", imgLink: "marta_bartolozzi.jpg" },
        { id: 18, name: "Gabriele Tagliaferri ", title: "U12 Baseball Coach", imgLink: "gabriele_tagliaferri.jpg" },
        { id: 19, name: "Tommaso Panichi", title: "Mini Baseball", imgLink: "tommaso_panichi.jpg" },
        { id: 20, name: "Juana Pujols", title: "Mini Baseball", imgLink: "juana_pujols.jpg" }
    ]

    constructor(props) {
        super(props)

        this.state = {
            options: {
                loop: true,
                margin: 10,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true,
                        dots: false
                    },
                    600: {
                        items: 3,
                        nav: true,
                        dots: false
                    },
                    1000: {
                        items: 4,
                        nav: true,
                        dots: false
                    },
                    1800: {
                        items: 5,
                        nav: true,
                    }
                }
            }
        }
    }

    render() {
        return (
            <section className="section bg-light-gray" id="staff" key="staff">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-md-8 text-center">
                            <h2 className="section-heading h1 text-dark mb-30">Lo staff</h2>
                            <p className="mb-40">
                                La forza della società
                            </p>
                        </div>
                    </div>
                </div>
                <div className="carousel-fluid" id="staff-1" key="staff-carousel-container">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-md-12">
                            <ReactOwlCarousel center loop nav margin={30} items={4} key={Math.random().toString(36).substring(7)} id="staff-carousel" className='owl-theme' {...this.state.options}>
                                {
                                    this.staff.map(staffMember => <StaffMemberCard staffMember={staffMember}></StaffMemberCard>)
                                }
                            </ReactOwlCarousel>
                        </div>
                    </div>
                </div>
            </section >
        );
    }
}

export default Staff;